// extracted by mini-css-extract-plugin
export default {"skill24":"Skill_skill24__Mr6uc","skill24_key":"Skill_skill24_key__hLE1G","loading":"Skill_loading__R4C-H"};